import { Capacitor } from "@capacitor/core";

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

export const getNativePlatform = (): "ios" | "android" | "web" =>
  Capacitor.getPlatform() as "ios" | "android" | "web";

export const isAndroid = (): boolean => getNativePlatform() === "android";

export const isIOS = (): boolean => getNativePlatform() === "ios";

export const isWeb = (): boolean => getNativePlatform() === "web";
